import { useEffect } from "react";

// Lightweight client-side SEO: title, meta description, and optional JSON-LD
export const Seo = ({ title, description, jsonLd }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      script.setAttribute("data-seo", "true");
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
    // `script`/`tag` are locals created inside this effect, not reactive deps.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, jsonLd]);
  return null;
};

export default Seo;
